import { useParams, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Container, Typography, DialogContent, Skeleton } from '@mui/material';
import React, { Component, useEffect, useState } from 'react'
import {
    PatientHeaderContainer, Part1, Part2, AddItemButton, MenuOptions, TwoIconContainer, PrevNextIconContainer, PatientDp,
    PatientDetails, Name_TagContainer, AllDetails, Name, TagsContainer, Tags, Icon_Text, Texts, EditIcon, TabsContainer,
    TabsData, Name_PatientInfo, PatientInfoPopUp, InfoName, StatusHeader, PatientName, PatientNameContainer,
    TwoBtns
} from './Style';
import { alpha, Box } from '@mui/material';
import CustomTabs from 'src/components/shared/CustomTabs/CustomTabs';
import { ReactComponent as AddIcon } from "../../../../../src/assets/images/add-square.svg";
import { ReactComponent as DropDown } from '../../../../../src/assets/images/arrow-down.svg';
import { ReactComponent as PrevIcon } from '../../../../../src/assets/images/arrow-left 2.svg';
import { ReactComponent as NextIcon } from '../../../../../src/assets/images/arrow-right 2.svg';
import { ReactComponent as Man } from '../../../../../src/assets/images/woman.svg';
import { ReactComponent as Calender } from '../../../../../src/assets/images/calendar.svg';
import { ReactComponent as Call } from '../../../../../src/assets/images/call.svg';
import { ReactComponent as Weight } from '../../../../../src/assets/images/weight.svg';
import { ReactComponent as Height } from '../../../../../src/assets/images/ruler.svg';

import { ReactComponent as Edit } from '../../../../../src/assets/images/edit-2.svg';
import theme, { components, mobileTypography, palette, typography } from 'src/config/theme';
import History from './Histroy/History';
import CaseHistory from './CaseHistory/CaseHistory';
import { getActiveCase } from 'src/modules/app/api/appApi';
import Appointments from './Appointments/Appointments';
import Notes from './Notes/Notes';
import Prescription from './Prescription/Prescription';
import FollowUps from './FollowUp/FollowUps';
import Payment from './Payments/Payment';
import Treatments from './Treatments/Treatments';
import Message from './Message/Message';
import Reports from './Reports/Reports';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import EditProfile from './Forms/EditProfile';
import { getAppointmentRequest, getAppointmentByIdRequest, getPatientByIdRequest, getPatientInfoByIdRequest, getTagByPatientIdRequest, getAreaByPatientIdRequest, updateRecordStatusRequest } from '../../store/appActions';
import { useDispatch, useSelector } from 'react-redux';
import useResponsive from 'src/components/hooks/useResponsive';
import NotesTabForm from './Forms/NotesTabForm';
import AppointmentTabForm from './Forms/AppointmentTabForm';
import FollowUpTabForm from './Forms/FollowUpTabForm';
import PaymentTabForm from './Forms/PaymentTabForm';
import PrescriptionTabForm from './Forms/PrescriptionTabForm';
import ReportTabForm from './Forms/ReportTabForm';
import MessageTabForm from './Forms/MessageTabForm';
import TreatmentTabForm from './Forms/TreatmentTabForm';
import { ReactComponent as InfoCircle } from '../../../../assets/images/info-circle.svg';
import storage from 'src/utils/storageUtils';
import PatientInfo from './PatientInfoDrawer/PatientInfo';
import DeleteDialog from '../DeleteDialog';
import ButtonComponent from 'src/components/shared/Button';
import useAppointmentDetails from '../UseAppointmentDetails';

function Patients() {
    const [appointments, setAppointments] = useState([]);
    const [navigationDirection, setNavigationDirection] = useState(null);

    const { appointmentId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const appointmentList = location.state?.appointmentList || [];

    console.log("appointmentId from URL:", appointmentId);
    console.log("appointmentList from location.state:", appointmentList);


    const [shouldRefresh, setShouldRefresh] = useState(false);
    const handleSuccess = () => {
        setShouldRefresh(prev => !prev);
        handleAddItemClose();
    };
    const [isPermanentOpen, setIsPermanentOpen] = useState(storage.get('IsPermanentOpen') === 'true');
    const drawerWidth = '280px';
    const dispatch = useDispatch();

    useEffect(() => {
        const handleStorageChange = () => {
            setIsPermanentOpen(storage.get('IsPermanentOpen') === 'true');
        };
        window.addEventListener('sidebarToggled', handleStorageChange);
        return () => window.removeEventListener('sidebarToggled', handleStorageChange);
    }, []);
    const [statusSelectOpen, setStatusSelectOpen] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openComplete, setOpenComplete] = useState(false);
    const [selectedMenuLabel, setSelectedMenuLabel] = useState("Add Item");
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const [addItemOpen, setAddItemOpen] = useState(false);
    const handleMenuClick = (type) => {
        setSelectedMenuLabel(type);
        setAddItemOpen(true);
        console.log(`${type} clicked`);
    };
    const handleAddItemClose = () => {
        setAddItemOpen(false);
        setSelectedMenuLabel("Add Item");
    };
    const tabsData = [

        { label: "Appointments", component: <Appointments shouldRefresh={shouldRefresh} /> },
        { label: "History", component: <History /> },
        { label: "Case History", component: <CaseHistory /> },
        { label: "Notes", component: <Notes shouldRefresh={shouldRefresh} /> },
        { label: "Prescriptions", component: <Prescription shouldRefresh={shouldRefresh} /> },
        { label: "Follow-ups", component: <FollowUps shouldRefresh={shouldRefresh} /> },
        { label: "Treatment", component: <Treatments shouldRefresh={shouldRefresh} /> },
        { label: "Reports", component: <Reports shouldRefresh={shouldRefresh} /> },
        { label: "Payments", component: <Payment shouldRefresh={shouldRefresh} /> },
        { label: "Message", component: <Message shouldRefresh={shouldRefresh} /> },

    ];
    const menuOptions = [
        { label: "Add Appointment", onClick: () => handleMenuClick("Add Appointment") },
        { label: "Add Notes", onClick: () => handleMenuClick("Add Notes") },
        { label: "Add Prescription", onClick: () => handleMenuClick("Add Prescription") },
        { label: "Add Follow-up", onClick: () => handleMenuClick("Add Follow-up") },
        { label: "Add Payment", onClick: () => handleMenuClick("Add Payment") },
        { label: "Add Treatment", onClick: () => handleMenuClick("Add Treatment") },
        { label: "Add Message", onClick: () => handleMenuClick("Add Message") },
        { label: "Add Report", onClick: () => handleMenuClick("Add Report") },
    ];
    const formComponents = {
        "Add Appointment": <AppointmentTabForm onClose={handleAddItemClose} fetchAppointments={handleSuccess} />,
        "Add Notes": <NotesTabForm onClose={handleAddItemClose} fetchNotes={handleSuccess} />,
        "Add Prescription": <PrescriptionTabForm onClose={handleAddItemClose} fetchPrescription={handleSuccess} />,
        "Add Follow-up": <FollowUpTabForm onClose={handleAddItemClose} fetchFollowUps={handleSuccess} />,
        "Add Payment": <PaymentTabForm onClose={handleAddItemClose} fetchPayments={handleSuccess} />,
        "Add Treatment": <TreatmentTabForm onClose={handleAddItemClose} fetchTreatments={handleSuccess} />,
        "Add Message": <MessageTabForm onClose={handleAddItemClose} fetchMessages={handleSuccess} />,
        "Add Report": <ReportTabForm onClose={handleAddItemClose} fetchReports={handleSuccess} />,
    };
    const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const appointmentData = useSelector((state) => state.app.tokenAppointmentsById);
    const patientData = useSelector((state) => state.app.patientById);
    const patientInfoData = useSelector((state) => state.app.patientInfoById);
    const TagData = useSelector((state) => state.app.TagByPatientId);
    const TagArray = TagData?.payload?.data?.[0] || {};
    const patientInfoDetails = patientInfoData?.payload?.data?.[0] || {};
    const patientDetails = patientData?.payload?.data?.patient;
    const { PatientId, user, clinicId, appointmentDetails } = useAppointmentDetails();
    const areaData = useSelector((state) => state.app.AreaByPatientId?.payload?.data);
    const isLoading = useSelector((state) => state.app.isLoading);
    const areaId = areaData?.[0]?.id;
    const [activeCaseInfo, setActiveCaseInfo] = useState(null);

    useEffect(() => {
        const fetchActiveCase = async () => {
            if (PatientId && user && clinicId) {
                try {
                    const response = await getActiveCase({ patient: PatientId, doctor: user, clinic: clinicId });
                    if (response && response.activeCase) {
                        setActiveCaseInfo(response.activeCase);
                    } else {
                        setActiveCaseInfo(null);
                    }
                } catch (err) {
                    console.error("Error fetching active case:", err);
                }
            }
        };
        fetchActiveCase();
    }, [PatientId, user, clinicId, shouldRefresh]);

    useEffect(() => {
        if (PatientId) {
            dispatch(getPatientByIdRequest(PatientId));
            dispatch(getPatientInfoByIdRequest(PatientId));
            dispatch(getTagByPatientIdRequest(PatientId));
            dispatch(getAreaByPatientIdRequest(PatientId))
        }
        if (appointmentId) {
            dispatch(getAppointmentByIdRequest(appointmentId));
        }
    }, [PatientId, appointmentId, dispatch, shouldRefresh]);
    const currentIndex = appointments.findIndex(a => a.id === appointmentId);
    const isFirst = currentIndex <= 0 && currentIndex !== -1;
    const isLast = currentIndex !== -1 && currentIndex === appointments.length - 1;

    useEffect(() => {
        if (location.state?.appointmentList && location.state.appointmentList.length > 0) {
            setAppointments(location.state.appointmentList);
            return;
        }

        const fetchAppointments = async () => {
            const token = storage.get('TOKEN');
            const params = {
                clinicId: clinicId,
                limit: 100, // Fetch a larger set to ensure current appointment is likely included
            };
            const response = await new Promise((resolve, reject) =>
                dispatch(getAppointmentRequest({ token, params }, resolve, reject))
            );

            if (response && response.data) {
                const FilteredData = response.data.filter(appointment => 
                    ['In Queue', 'Attending Now', 'Scheduled', 'Treatment Scheduled', 'Complete'].includes(appointment.recordStatus)
                );
                console.log("Filtered response:", FilteredData);
                setAppointments(FilteredData);
            } else {
                console.error("Expected an array but got:", response);
            }
        };

        if (clinicId) {
            fetchAppointments();
        }
    }, [dispatch, appointmentId, location.state?.appointmentList, clinicId]);


    const handleNext = () => {
        if (!isLast) {
            const currentStatus = appointmentDetails?.recordStatus;
            const nextId = appointments[currentIndex + 1]?.id;

            if (currentStatus === 'Attending Now') {
                setNavigationDirection('next');
                setSelectedAppointmentId(appointmentId);
                setSelectedPatient(patientDetails);
                setOpenComplete(true);
            } else {
                navigate(`/appointment/Patients/${nextId}`, { state: { appointmentList: appointments } });
            }
        }
    };

    const handlePrev = () => {
        if (!isFirst) {
            const prevId = appointments[currentIndex - 1]?.id;
            navigate(`/appointment/Patients/${prevId}`, { state: { appointmentList: appointments } });
        }
    };

    const handleCompleteOpen = (appointmentId, patientData) => {
        setSelectedAppointmentId(appointmentId);
        setSelectedPatient(patientData)
        setOpenComplete(true);
    }
    const handleCompleteClose = () => {
        setSelectedAppointmentId(null);
        setSelectedPatient(null)
        setOpenComplete(false);
    }

    const updateAppointmentStatus = async (appointmentId, status, onSuccess) => {
        const updatedData = { recordStatus: status };

        try {
            const response = await new Promise((resolve, reject) => {
                dispatch(updateRecordStatusRequest(appointmentId, updatedData, resolve, reject));
            });

            if (response) {
                console.log(`Status updated successfully to ${status}`);

                setAppointments((prevAppointments) =>
                    prevAppointments.map((appointment) =>
                        appointment.id === appointmentId
                            ? { ...appointment, recordStatus: status }
                            : appointment
                    )
                );
                if (onSuccess) onSuccess();
            }
        } catch (error) {
            console.error(`Failed to update status to ${status}:`, error);
        }
    };
    const handleCompleteAppointment = (appointmentId) => {
        updateAppointmentStatus(appointmentId, "Complete", () => {
            handleCompleteClose();

            const currentIndex = appointments.findIndex(a => a.id === appointmentId);
            const nextId = appointments[currentIndex + 1]?.id;
            const prevId = appointments[currentIndex - 1]?.id;

            if (navigationDirection === 'next' && nextId) {
                navigate(`/appointment/Patients/${nextId}`, { state: { appointmentList: appointments } });
            } else if (navigationDirection === 'prev' && prevId) {
                navigate(`/appointment/Patients/${prevId}`, { state: { appointmentList: appointments } });
            }

            setNavigationDirection(null);
        });
    };
    const goToNextAppointment = () => {
        const currentIndex = appointments.findIndex(a => a.id === appointmentId);
        const nextId = appointments[currentIndex + 1]?.id;
        const prevId = appointments[currentIndex - 1]?.id;

        if (navigationDirection === 'next' && nextId) {
            navigate(`/appointment/Patients/${nextId}`, { state: { appointmentList: appointments } });
        } else if (navigationDirection === 'prev' && prevId) {
            navigate(`/appointment/Patients/${prevId}`, { state: { appointmentList: appointments } });
        }

        setNavigationDirection(null);
    };


    return (
        <>
            <Container maxWidth="xxl" disableGutters sx={{ backgroundColor: theme.palette.gery.extraLightGray, width: '100%' }}>
                <PatientHeaderContainer
                    sx={{
                        position: 'fixed',
                        left: {
                            xs: 0,
                            sm: 0,
                            md: isPermanentOpen ? drawerWidth : '80px',
                        },
                        right: 0,
                        top: isMobile || isTablet ? '72px' : '84px',
                        zIndex: '1000',
                        paddingLeft: isDesktop ? '60px' : '20px',
                    }}
                >
                    <Part1>
                        {isLoading ? (
                            <Skeleton variant="rounded" width={70} height={70} sx={{ borderRadius: '12px' }} />
                        ) : (
                            <PatientDp 
                                sx={{ bgcolor: theme.palette.primary.light3 }}
                            >
                                {patientDetails?.fullName?.charAt(0).toUpperCase() || 'N/A'}
                            </PatientDp>
                        )}

                        {(isMobile || isTablet) && (
                            <Name_PatientInfo>
                                {isLoading ? (
                                    <Skeleton width={120} height={30} />
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Name>{patientDetails?.fullName || 'N/A'}</Name>
                                        {activeCaseInfo ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                                                <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#4CAF50' }} />
                                                <Typography variant="caption" sx={{ color: '#4CAF50', fontWeight: 600, fontSize: '11px' }}>
                                                    Active: {activeCaseInfo.caseNumber}
                                                </Typography>
                                            </Box>
                                        ) : (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                                                <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#F44336' }} />
                                                <Typography variant="caption" sx={{ color: '#F44336', fontWeight: 600, fontSize: '11px' }}>
                                                    No Active Case
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                )}
                                <PatientInfoPopUp onClick={() => setSidebarOpen(true)}>
                                    <InfoCircle width={18} height={18} color={palette.primary.main} />
                                    <InfoName>Info</InfoName>
                                </PatientInfoPopUp>
                            </Name_PatientInfo>
                        )}
                        {isDesktop && (
                            <PatientDetails>
                                <Name_TagContainer>
                                    {isLoading ? (
                                        <Skeleton width={250} height={35} />
                                    ) : (
                                        <>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <Name>{patientDetails?.fullName || 'N/A'}</Name>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}>
                                                        ID: {patientDetails?.patientId || 'N/A'}
                                                    </Typography>
                                                    {activeCaseInfo ? (
                                                        <Box sx={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            gap: '6px', 
                                                            px: '8px', 
                                                            py: '2px', 
                                                            borderRadius: '6px', 
                                                            backgroundColor: 'rgba(76, 175, 80, 0.08)',
                                                            border: '1px solid rgba(76, 175, 80, 0.25)' 
                                                        }}>
                                                            <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#4CAF50' }} />
                                                            <Typography variant="caption" sx={{ color: '#4CAF50', fontWeight: 600, fontSize: '11px', lineHeight: 1 }}>
                                                                Active Case: {activeCaseInfo.caseNumber} (Valid till: {dayjs(activeCaseInfo.validityEndDate).format('DD-MMM')})
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            gap: '6px', 
                                                            px: '8px', 
                                                            py: '2px', 
                                                            borderRadius: '6px', 
                                                            backgroundColor: 'rgba(244, 67, 54, 0.08)',
                                                            border: '1px solid rgba(244, 67, 54, 0.25)' 
                                                        }}>
                                                            <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#F44336' }} />
                                                            <Typography variant="caption" sx={{ color: '#F44336', fontWeight: 600, fontSize: '11px', lineHeight: 1 }}>
                                                                No Active Case
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                            <TagsContainer>
                                                {Array.isArray(TagArray?.tag) && TagArray.tag.length > 0 ? (
                                                    TagArray.tag.map((tagLabel, index) => (
                                                        <Tags key={index} label={tagLabel} />
                                                    ))
                                                ) : (
                                                    <Tags label="No tags available" />
                                                )}
                                            </TagsContainer>
                                        </>
                                    )}
                                </Name_TagContainer>
                                <AllDetails>
                                    {isLoading ? (
                                        <Skeleton width="100%" height={24} />
                                    ) : (
                                        <>
                                            <Icon_Text>
                                                <Man />
                                                <Texts>{patientDetails?.gender ? patientDetails.gender.charAt(0).toUpperCase() + patientDetails.gender.slice(1).toLowerCase() : 'N/A'}</Texts>
                                            </Icon_Text>
                                            <Icon_Text>
                                                <Calender />
                                                <Texts>{(function() {
                                                    const ageStr = patientDetails?.detailedAge?.ageString;
                                                    if (ageStr) return ageStr;
                                                    if (patientDetails?.dateOfBirth) {
                                                        const birth = dayjs(patientDetails.dateOfBirth);
                                                        const now = dayjs();
                                                        const years = now.diff(birth, 'year');
                                                        const months = now.diff(birth.add(years, 'year'), 'month');
                                                        const days = now.diff(birth.add(years, 'year').add(months, 'month'), 'day');
                                                        return `${years} ${years === 1 ? 'Year' : 'Years'} ${months} ${months === 1 ? 'Month' : 'Months'} ${days} ${days === 1 ? 'Day' : 'Days'}`;
                                                    }
                                                    return patientDetails?.age ? `${patientDetails.age} ${patientDetails.age === 1 ? 'Year' : 'Years'}` : 'N/A';
                                                })()}</Texts>
                                            </Icon_Text>
                                            <Icon_Text title="Weight">
                                                <Weight />
                                                <Texts>{patientInfoDetails?.weight || 'N/A'}</Texts>
                                            </Icon_Text>
                                            <Icon_Text title="Height">
                                                <Height />
                                                <Texts>{patientInfoDetails?.height || 'N/A'}</Texts>
                                            </Icon_Text>
                                            <Icon_Text title="Pulse Rate">
                                                <Texts>P: {patientInfoDetails?.pulseRate || 'N/A'}</Texts>
                                            </Icon_Text>
                                            <Icon_Text title="SpO2">
                                                <Texts>O2: {patientInfoDetails?.spo2 ? `${patientInfoDetails.spo2}%` : 'N/A'}</Texts>
                                            </Icon_Text>
                                            <Icon_Text title="Temperature">
                                                <Texts>T: {patientInfoDetails?.temperature ? `${patientInfoDetails.temperature}°F` : 'N/A'}</Texts>
                                            </Icon_Text>

                                            <EditIcon onClick={handleOpen}>
                                                <Edit width="24px" height="24px" style={{ color: theme.palette.primary.main }} />
                                            </EditIcon>
                                        </>
                                    )}
                                </AllDetails>
                            </PatientDetails>
                        )}
                    </Part1>
                    <Part2>
                        <TwoIconContainer>
                            <PrevNextIconContainer
                                onClick={handlePrev}
                                sx={{
                                    opacity: isFirst ? 0.5 : 1,
                                    pointerEvents: isFirst ? 'none' : 'auto',
                                }}
                                disabled={isFirst}
                            >
                                <PrevIcon width="24px" height="24px" />
                                {isDesktop && "Prev"}
                            </PrevNextIconContainer>

                            <PrevNextIconContainer
                                onClick={handleNext}

                                sx={{
                                    opacity: isLast ? 0.5 : 1,
                                    pointerEvents: isLast ? 'none' : 'auto',
                                }}
                                disabled={isLast}
                            >
                                {isDesktop && "Next"}
                                <NextIcon width="24px" height="24px" />
                            </PrevNextIconContainer>
                        </TwoIconContainer>
                    </Part2>
                </PatientHeaderContainer>
                <TabsContainer
                    sx={{
                        position: 'fixed',
                        right: 0,
                        top: isMobile || isTablet ? '72px' : '84px',
                        width: {
                            xs: '100%',
                            sm: '100%',
                            md: isPermanentOpen ? `calc(100% - ${drawerWidth})` : 'calc(100% - 88px)',
                        },
                        marginTop: isMobile || isTablet ? '80px' : '100px',
                        zIndex: '1000'
                    }}
                >
                    <CustomTabs
                        value={selectedTab}
                        tabs={tabsData}
                        onChange={(index) => setSelectedTab(index)}
                        sx={{
                            tabStyles: {
                                color: `${alpha(palette.gery.black, 0.7)}`,
                                selectedColor: palette.primary.main,
                                height: "56px",
                                fontSize: '17px',
                                fontWeight: '400px',
                                lineHeight: '21.62px',


                            },
                            indicatorStyles: {
                                color: palette.primary.main,
                                height: "2px",
                            },
                        }}
                    />
                </TabsContainer>
                <TabsData >
                    {tabsData[selectedTab].component}
                </TabsData>
                <DialogBox open={open}
                    PaperProps={{
                        sx: {
                            maxWidth: 'none',
                        }
                    }}>
                    <EditProfile onClose={handleClose} />
                </DialogBox>
                <DialogBox
                    open={addItemOpen}
                    onClose={handleAddItemClose}
                    PaperProps={{
                        sx: {
                            // maxWidth: 'none',
                            margin: '0 !important'
                        },
                    }}
                >
                    <Box key={selectedMenuLabel}>
                        {formComponents[selectedMenuLabel]}
                    </Box>
                </DialogBox>
            </Container>

            <PatientInfo open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <DeleteDialog
                open={openComplete}
                onClose={handleCompleteClose}
                onCancel={() => {
                    handleCompleteClose();
                    setStatusSelectOpen(true);
                }}
                onConfirm={handleCompleteAppointment}
                idToDelete={appointmentId}
                title="Complete Appointment?"
                message={`Would you like to complete the appointment of ${patientDetails?.fullName} before moving to the next?`}
                confirmText="OK"
            />

            <DialogBox open={statusSelectOpen} onClose={() => setStatusSelectOpen(false)}>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <StatusHeader  >
                        What status would you like to keep for   </StatusHeader>
                    <PatientNameContainer >
                        <PatientName>{patientDetails?.fullName}</PatientName>
                    </PatientNameContainer>

                    <TwoBtns>


                        <ButtonComponent
                            sx={{ mb: 1 }}
                            onClick={() => {
                                updateAppointmentStatus(appointmentId, "Attending Now", () => setStatusSelectOpen(false));
                                goToNextAppointment();
                            }}
                        >
                            Attending Now
                        </ButtonComponent>
                        <ButtonComponent
                            onClick={() => {
                                updateAppointmentStatus(appointmentId, "In Queue", () => setStatusSelectOpen(false));
                                goToNextAppointment();
                            }}
                        >
                            In Queue
                        </ButtonComponent>
                    </TwoBtns>
                </DialogContent>
            </DialogBox>

        </>
    )
}
export default Patients;
